import React, { createContext, useContext, useState, useEffect, useMemo } from "react";

const TRANSLATIONS = {
  fr: {
    app_name: "FilePro",
    tagline: "Gestion intelligente des files d'attente pour cliniques",
    login: "Connexion",
    logout: "Déconnexion",
    email: "Adresse email",
    password: "Mot de passe",
    sign_in: "Se connecter",
    invalid_credentials: "Identifiants invalides",
    change_password_required: "Changement de mot de passe requis",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    update_password: "Mettre à jour",
    password_updated: "Mot de passe mis à jour",
    dashboard: "Tableau de bord",
    staff: "Personnel",
    kiosk: "Borne patient",
    display: "Écran d'affichage",
    super_admin: "Super Admin",
    admin: "Administration",
    welcome: "Bienvenue",
    select_service: "Sélectionnez un service",
    take_ticket: "Prendre un ticket",
    ticket_number: "Numéro de ticket",
    estimated_wait: "Temps d'attente estimé",
    minutes: "min",
    now_serving: "En cours",
    room: "Salle",
    upcoming: "À venir",
    waiting: "En attente",
    called: "Appelé",
    done: "Terminé",
    absent: "Absent",
    urgent: "Urgent",
    call_next: "Appeler le suivant",
    recall: "Rappeler",
    mark_absent: "Marquer absent",
    complete: "Terminer",
    transfer: "Transférer",
    current_patient: "Patient actuel",
    waiting_list: "File d'attente",
    no_patient_waiting: "Aucun patient en attente",
    select_counter: "Sélectionner votre salle",
    todays_traffic: "Trafic aujourd'hui",
    avg_wait_time: "Temps d'attente moyen",
    patients_by_service: "Patients par service",
    hourly_traffic: "Trafic horaire",
    staff_performance: "Performance du personnel",
    total_today: "Total aujourd'hui",
    tenants: "Cliniques",
    users: "Utilisateurs",
    tickets_today: "Tickets aujourd'hui",
    get_started: "Commencer",
    try_demo: "Essayer la démo",
    features_title: "Tout ce qu'il vous faut pour accueillir vos patients",
    feature_kiosk: "Borne tactile patient",
    feature_kiosk_desc: "Interface simple et accessible pour générer des tickets en quelques secondes.",
    feature_realtime: "Temps réel WebSocket",
    feature_realtime_desc: "Tous les écrans se mettent à jour instantanément sans rechargement.",
    feature_priority: "Priorité Urgence",
    feature_priority_desc: "Les cas d'urgence passent automatiquement en tête de file.",
    feature_dashboard: "Tableau de bord analytique",
    feature_dashboard_desc: "Métriques de performance et trafic détaillés par service et par agent.",
    feature_multitenant: "Multi-clinique sécurisé",
    feature_multitenant_desc: "Isolation stricte par tenant_id. Un super admin pour toutes vos cliniques.",
    feature_bilingual: "Bilingue FR / EN",
    feature_bilingual_desc: "Prêt pour l'international dès le premier jour.",
    demo_banner: "Mode démo — Clinique Santé Plus",
    print_ticket: "Imprimer le ticket",
    new_ticket: "Nouveau ticket",
    thank_you: "Merci, votre ticket a été créé",
    please_wait_called: "Veuillez patienter, votre numéro sera appelé",
    back_to_home: "Retour à l'accueil",
    open_kiosk: "Ouvrir la borne",
    open_display: "Ouvrir l'écran",
    scan_qr: "Scannez le QR code",
    priority: "Priorité",
    platform_stats: "Statistiques de la plateforme",
    no_patient_details_notice: "Le super admin n'a pas accès aux détails patients — uniquement aux statistiques globales.",
    demo_readonly_notice: "Mode démo — les comptes démo ne peuvent pas modifier le mot de passe.",
    open_staff: "Interface personnel",
    open_admin: "Interface admin",
    your_ticket: "Votre ticket",
    patients: "patients",
    serving_now: "Patient en cours",
    next_up: "Prochains",
    forgot_password: "Mot de passe oublié ?",
    reset_password: "Réinitialiser le mot de passe",
    reset_sent: "Si un compte existe, un lien de réinitialisation a été envoyé.",
    reset_link_demo: "Lien de démo",
    send_reset_link: "Envoyer le lien",
    password_reset_success: "Mot de passe réinitialisé avec succès",
    go_to_login: "Aller à la connexion",
    overview: "Aperçu",
    services: "Services",
    counters: "Salles",
    manage_services: "Gérer les services",
    manage_counters: "Gérer les salles",
    manage_users: "Gérer le personnel",
    add_service: "Ajouter un service",
    add_counter: "Ajouter une salle",
    add_user: "Ajouter un utilisateur",
    name: "Nom",
    name_fr: "Nom (FR)",
    name_en: "Nom (EN)",
    prefix: "Préfixe",
    color: "Couleur",
    role: "Rôle",
    active: "Actif",
    actions: "Actions",
    edit: "Modifier",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    confirm_delete: "Confirmer la suppression ?",
    temp_password: "Mot de passe temporaire",
    copy: "Copier",
    copied: "Copié",
    demo_action_disabled: "Action désactivée en mode démo",
    new_password_min: "Minimum 8 caractères",
    ticket_printed_notice: "Votre ticket est imprimé. Veuillez patienter.",
    return_in: "Retour à l'accueil dans",
    reprint: "Réimprimer",
    kiosk_settings: "Paramètres borne",
    manage_kiosk: "Gérer la borne",
    auto_print: "Impression automatique",
    paper_width: "Largeur du papier",
    show_qr_label: "Afficher le QR code",
    copies_label: "Nombre de copies",
    confirmation_duration: "Durée de confirmation (ms)",
    setting_saved: "Paramètre enregistré",
    features_label: "Fonctionnalités",
    demo_accounts: "Comptes démo",
    use_account: "Utiliser",
    status: "Statut",
    time: "Heure",
    clinic: "Clinique",
    slug: "Identifiant",
    new_tenant: "Nouvelle clinique",
    create_tenant: "Créer une clinique",
    tenant_name: "Nom de la clinique",
    tenant_address: "Adresse",
    tenant_phone: "Téléphone",
    admin_email: "Email administrateur",
    admin_name: "Nom de l'administrateur",
    auto_password: "Mot de passe (laisser vide pour générer)",
    seed_defaults_label: "Pré-remplir avec 5 services + 3 salles",
    create: "Créer",
    tenant_created: "Clinique créée avec succès",
    demo_tenant_locked: "Clinique de démo — non supprimable",
    demo: "Démo",
    permissions: "Permissions",
    permission_dashboard: "Dashboard",
    permission_staff: "Personnel",
    permission_kiosk: "Borne",
    permission_display: "Écran",
    no_permission: "Vous n'avez pas accès à cette page.",
    permissions_updated: "Permissions mises à jour",
  },
  en: {
    app_name: "FilePro",
    tagline: "Smart queue management for clinics",
    login: "Sign in",
    logout: "Sign out",
    email: "Email address",
    password: "Password",
    sign_in: "Sign in",
    invalid_credentials: "Invalid credentials",
    change_password_required: "Password change required",
    current_password: "Current password",
    new_password: "New password",
    update_password: "Update",
    password_updated: "Password updated",
    dashboard: "Dashboard",
    staff: "Staff",
    kiosk: "Patient kiosk",
    display: "Display screen",
    super_admin: "Super Admin",
    admin: "Administration",
    welcome: "Welcome",
    select_service: "Select a service",
    take_ticket: "Take a ticket",
    ticket_number: "Ticket number",
    estimated_wait: "Estimated wait",
    minutes: "min",
    now_serving: "Now serving",
    room: "Room",
    upcoming: "Upcoming",
    waiting: "Waiting",
    called: "Called",
    done: "Done",
    absent: "Absent",
    urgent: "Urgent",
    call_next: "Call next",
    recall: "Recall",
    mark_absent: "Mark absent",
    complete: "Complete",
    transfer: "Transfer",
    current_patient: "Current patient",
    waiting_list: "Waiting list",
    no_patient_waiting: "No patient waiting",
    select_counter: "Select your room",
    todays_traffic: "Today's traffic",
    avg_wait_time: "Average wait time",
    patients_by_service: "Patients by service",
    hourly_traffic: "Hourly traffic",
    staff_performance: "Staff performance",
    total_today: "Total today",
    tenants: "Clinics",
    users: "Users",
    tickets_today: "Tickets today",
    get_started: "Get started",
    try_demo: "Try demo",
    features_title: "Everything you need to welcome your patients",
    feature_kiosk: "Patient touch kiosk",
    feature_kiosk_desc: "Simple and accessible interface to generate tickets in seconds.",
    feature_realtime: "Real-time WebSocket",
    feature_realtime_desc: "All screens update instantly without reloading.",
    feature_priority: "Emergency priority",
    feature_priority_desc: "Emergency cases automatically skip to the head of the queue.",
    feature_dashboard: "Analytics dashboard",
    feature_dashboard_desc: "Detailed performance metrics and traffic by service and agent.",
    feature_multitenant: "Secure multi-clinic",
    feature_multitenant_desc: "Strict tenant_id isolation. One super admin for all your clinics.",
    feature_bilingual: "Bilingual FR / EN",
    feature_bilingual_desc: "Ready for international rollout from day one.",
    demo_banner: "Demo mode — Clinique Santé Plus",
    print_ticket: "Print ticket",
    new_ticket: "New ticket",
    thank_you: "Thank you, your ticket has been created",
    please_wait_called: "Please wait, your number will be called",
    back_to_home: "Back to home",
    open_kiosk: "Open kiosk",
    open_display: "Open display",
    scan_qr: "Scan QR code",
    priority: "Priority",
    platform_stats: "Platform statistics",
    no_patient_details_notice: "Super admin has no access to patient details — only global stats.",
    demo_readonly_notice: "Demo mode — demo accounts cannot change their password.",
    open_staff: "Staff interface",
    open_admin: "Admin interface",
    your_ticket: "Your ticket",
    patients: "patients",
    serving_now: "Serving now",
    next_up: "Next up",
    forgot_password: "Forgot password?",
    reset_password: "Reset password",
    reset_sent: "If an account exists, a reset link has been sent.",
    reset_link_demo: "Demo link",
    send_reset_link: "Send reset link",
    password_reset_success: "Password reset successfully",
    go_to_login: "Go to sign in",
    overview: "Overview",
    services: "Services",
    counters: "Rooms",
    manage_services: "Manage services",
    manage_counters: "Manage rooms",
    manage_users: "Manage staff",
    add_service: "Add service",
    add_counter: "Add room",
    add_user: "Add user",
    name: "Name",
    name_fr: "Name (FR)",
    name_en: "Name (EN)",
    prefix: "Prefix",
    color: "Color",
    role: "Role",
    active: "Active",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    confirm_delete: "Confirm deletion?",
    temp_password: "Temporary password",
    copy: "Copy",
    copied: "Copied",
    demo_action_disabled: "Action disabled in demo mode",
    new_password_min: "Minimum 8 characters",
    ticket_printed_notice: "Your ticket has been printed. Please wait.",
    return_in: "Returning home in",
    reprint: "Reprint",
    kiosk_settings: "Kiosk settings",
    manage_kiosk: "Manage kiosk",
    auto_print: "Auto print",
    paper_width: "Paper width",
    show_qr_label: "Show QR code",
    copies_label: "Number of copies",
    confirmation_duration: "Confirmation duration (ms)",
    setting_saved: "Setting saved",
    features_label: "Features",
    demo_accounts: "Demo accounts",
    use_account: "Use",
    status: "Status",
    time: "Time",
    clinic: "Clinic",
    slug: "Slug",
    new_tenant: "New clinic",
    create_tenant: "Create clinic",
    tenant_name: "Clinic name",
    tenant_address: "Address",
    tenant_phone: "Phone",
    admin_email: "Admin email",
    admin_name: "Admin name",
    auto_password: "Password (leave empty to generate)",
    seed_defaults_label: "Seed 5 default services + 3 rooms",
    create: "Create",
    tenant_created: "Clinic created successfully",
    demo_tenant_locked: "Demo clinic — cannot be deleted",
    demo: "Demo",
    permissions: "Permissions",
    permission_dashboard: "Dashboard",
    permission_staff: "Staff",
    permission_kiosk: "Kiosk",
    permission_display: "Display",
    no_permission: "You don't have access to this page.",
    permissions_updated: "Permissions updated",
  },
};

const LanguageContext = createContext({ lang: "fr", setLang: () => {}, t: (k) => k });

function detectInitialLang() {
  try {
    const stored = typeof localStorage !== "undefined" ? localStorage.getItem("filepro_lang") : null;
    if (stored === "fr" || stored === "en") return stored;
    // First visit: prefer browser language if available, otherwise default to French
    const nav = (typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage)) || "";
    if (typeof nav === "string" && nav.toLowerCase().startsWith("en")) return "en";
    return "fr";
  } catch {
    return "fr";
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);
  useEffect(() => {
    try { localStorage.setItem("filepro_lang", lang); } catch { /* ignore */ }
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => {
    if (l !== "fr" && l !== "en") return;
    setLangState(l);
  };
  const t = useMemo(() => (key) => (TRANSLATIONS[lang] && TRANSLATIONS[lang][key]) || TRANSLATIONS.fr[key] || key, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useI18n = () => useContext(LanguageContext);
